import styles from "./Slider.module.scss";
import { SliderProps } from "./Slider.types";

const Slider = ({
  value,
  min,
  max,
  step,
  onChange,
  ariaLabel,
}: SliderProps) => (
  <div className={styles.sliderWrapper}>
    <input
      type="range"
      className="w-full range-progress"
      value={value}
      min={min}
      max={max}
      step={step}
      onChange={(e) => onChange(+e.target.value)}
      aria-label={ariaLabel}
      style={
        {
          "--value": value,
          "--min": min,
          "--max": max,
        } as React.CSSProperties
      }
    />
  </div>
);

export default Slider;
